import {DeviationStatus} from '../../../components/Common/Types/DeviationStatus';
import request from '../../../components/Infrastructure/Requests/Request';
import Authentication from '../../../components/Infrastructure/Authentication/Authentication';
import {DeviationInfo} from '../../../components/Services/Deviations/DeviationInfo';
import {IServerSideGetRowsRequest} from 'ag-grid-enterprise';
import {getFilterParams, getSortParms} from '../Helpers/AgGridReactSSRQueryBuilder';

export class DeviationService {
	public static async GetDeviationStatus(): Promise<DeviationStatus[]> {
		let deviationStatus = [];
		try {
			deviationStatus = (
				await request({
					url: '/deviations_status',
					method: 'GET',
					token: Authentication.getToken(),
				})
			).data;
		} catch (e) {
			console.error(e);
		}

		return deviationStatus.map(d => new DeviationStatus(d));
	}

	public static async GetDeviations(params: IServerSideGetRowsRequest): Promise<{total: number; deviations: DeviationInfo[]}> {
		let sortParms = getSortParms(params);
		let filterParams = getFilterParams(params);
		let total: number;

		const deviationRequestOptions: any = {
			url: `/deviations_info?limit=${params.endRow - params.startRow}&offset=${params.startRow}${sortParms}${filterParams}`,
			method: 'GET',
			token: Authentication.getToken(),
		};

		// Only set Prefer header if filterParams are set
		if (filterParams) {
			deviationRequestOptions.headers = {Prefer: 'count=exact'};
		}

		let statsPromise: Promise<any> | undefined;
		if (!filterParams) {
			statsPromise = request({
				url: '/deviation_stats',
				method: 'GET',
				token: Authentication.getToken(),
			});
		}

		const [res, stats] = await Promise.all([request(deviationRequestOptions), statsPromise ?? Promise.resolve(undefined)]);

		// If filterParams are set, use content-range header for total
		if (filterParams) {
			total = parseInt(res.headers['content-range'].split('/')[1], 10);
		} else if (stats) {
			total = stats.data.length > 0 ? stats.data[0].count : 0;
		}

		return {
			total,
			deviations: res.data,
		};
	}
}
